module.exports = __webpack_public_path__ + "img/b_5.1cce5d23.jpg";